import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRegionsList, createRegion, updateRegion, removeRegion } from 'services/api';
import type { RootState } from 'shared/services/redux/types';
import type { RegionsListRequest, CreateRegionBody, UpdateRegionBody } from 'services/api';

export const getRegionsListAction = createAsyncThunk(
  'regions/getList',
  async (params: RegionsListRequest) => {
    try {
      return await getRegionsList(params);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const createRegionAction = createAsyncThunk(
  'regions/create',
  async (body: CreateRegionBody) => {
    try {
      return await createRegion(body);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const updateRegionAction = createAsyncThunk(
  'regions/update',
  async (body: UpdateRegionBody, thunkApi) => {
    const {
      regionsState: { selectedRegion },
    } = thunkApi.getState() as RootState;
    try {
      return await updateRegion(selectedRegion!.id, body);
    } catch (error: unknown) {
      throw new Error(error as string);
    }
  },
);

export const removeRegionAction = createAsyncThunk('regions/remove', async (regionId: number) => {
  try {
    await removeRegion(regionId);
    return regionId;
  } catch (error: unknown) {
    throw new Error(error as string);
  }
});
